import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog, faSlidersH, faCheckCircle, faQuoteLeft, faQuoteRight } from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faLinkedinIn,
  faTwitter,
  faBehance,
} from "@fortawesome/free-brands-svg-icons";
import classNames from "classnames";
import PropTypes from "prop-types";
import Testimonials from "../HomePage/Testimonials";
import { FaAngleRight } from 'react-icons/fa';
import Team from "./Team";
import Aboutus from '../../assets/aboutus-1.jpeg';

const features = [
  {
    icon: faCog,
    title: "Mission",
    desc: "To empower people and organisation through strategic planning and innovative solutions, to drive sustainable growth and success",
  },
  {
    icon: faSlidersH,
    title: "Vision",
    desc: "Our vision is to be the most trusted and reliable financial partner.",
  },
];

const FeaturedItem = ({ feature, index }) => {
  return (
    <div
      className={classNames("bg-white rounded-xl p-6", {
        "mb-6": !index,
      })}
    >
      <div className="flex items-center mb-4">
        <div className="flex items-center justify-center text-base p-4 text-white rounded-xl bg-darkBlue mr-3">
          <FontAwesomeIcon icon={feature.icon} />
        </div>
        <h4 className="text-xl">{feature.title}</h4>
      </div>
      <p className="opacity-80 px-2">{feature.desc}</p>
    </div>
  );
};

const features1 = [
  {
    title: " With tools like our Financial Health Calculator, we empower you to make informed decisions and track your progress towards achieving your financial goals.",
  },
  {
    title: "From retirement planning to tax consulting, we offer a wide range of services to meet all your financial needs under one roof.",
  },
  {
    title: "“We’ve been serving clients across India, helping them secure their future with confidence. Our client's success is our success.",
  },
];

const FeaturedItem1 = ({ feature }) => {
  return (
    <div className="flex items-center mt-4 md:mt-6">
      <div className="mr-4">
        <span className="bg-blue-600 bg-opacity-10 text-blue-600 w-10 h-10 rounded-full text-xl inline-flex items-center justify-center">
          <FontAwesomeIcon icon={faCheckCircle} />
        </span>
      </div>
      <div>
        <p className="opacity-80">{feature.title}</p>
      </div>
    </div>
  );
};


FeaturedItem.propTypes = {
  feature: PropTypes.object.isRequired,
  index: PropTypes.number,
};


const teamMembers = [
  {
    picture: "https://cdn.easyfrontend.com/pictures/users/user24.jpg",
    fullName: "Akshay Kumar",
    designation: "Founder / CEO",
    bio: "Subscribe Easy Tutorials Youtube Channel watch more videos",
    socialLinks: [
      { icon: faFacebookF, href: "#" },
      { icon: faLinkedinIn, href: "#" },
      { icon: faTwitter, href: "#" },
      { icon: faBehance, href: "#" },
    ],
  },
  {
    picture: "https://cdn.easyfrontend.com/pictures/users/user9.jpg",
    fullName: "Raima Ray",
    designation: "Business Head",
    bio: "Subscribe Easy Tutorials Youtube Channel watch more videos",
    socialLinks: [
      { icon: faFacebookF, href: "#" },
      { icon: faLinkedinIn, href: "#" },
      { icon: faTwitter, href: "#" },
      { icon: faBehance, href: "#" },
    ],
  },
  {
    picture: "https://cdn.easyfrontend.com/pictures/users/user23.jpg",
    fullName: "Arjun Kapur",
    designation: "UI Design",
    bio: "Subscribe Easy Tutorials Youtube Channel watch more videos",
    socialLinks: [
      { icon: faFacebookF, href: "#" },
      { icon: faLinkedinIn, href: "#" },
      { icon: faTwitter, href: "#" },
      { icon: faBehance, href: "#" },
    ],
  },
  {
    picture: "https://cdn.easyfrontend.com/pictures/users/user13.jpg",
    fullName: "Alia Bhatt",
    designation: "Marketing Head",
    bio: "Subscribe Easy Tutorials Youtube Channel watch more videos",
    socialLinks: [
      { icon: faFacebookF, href: "#" },
      { icon: faLinkedinIn, href: "#" },
      { icon: faTwitter, href: "#" },
      { icon: faBehance, href: "#" },
    ],
  },
];

const TeamMemberItem = ({ member }) => (
  <div className="bg-white shadow-xl rounded-xl hover:-translate-y-1 duration-500 h-full p-6 lg:p-8">
    <img
      src={member.picture}
      alt={member.fullName}
      className="max-w-full h-auto rounded-full border-4 p-1 border-darkBlue mx-auto"
      width="120"
    />
    <div className="mt-6">
      <h4 className="text-2xl font-medium mb-1">{member.fullName}</h4>
      <p className="mb-4 text-sm">{member.designation}</p>
      <p className="opacity-50">{member.bio}</p>
      <div className="mt-6">
        {member.socialLinks.map((item, i) => (
          <a
            href={item.href}
            className={`inline-block opacity-60 transition duration-300 hover:translate-y-1 hover:opacity-100 ${i + 1 !== member.socialLinks.length && "mr-4"
              }`}
            key={i}
          >
            <FontAwesomeIcon icon={item.icon} />
          </a>
        ))}
      </div>
    </div>
  </div>
);

TeamMemberItem.propTypes = {
  member: PropTypes.object.isRequired,
};

const testimonial = {
  name: "Praveen More",
  content:
    "The more you react,the more to tend to loose it.",
};


const About = () => {
  const { img, name, position, content } = testimonial;

  return (
    <React.Fragment>
      <section className="bg-darkBlue text-white min-h-[30vh] md:min-h-[30vh] flex items-center justify-center" style={{ paddingTop: '0.5rem' }}>
        <div className="max-w-7xl px-4 mx-auto">
          <div className="grid grid-cols-12 items-center justify-center">
            <div className="col-span-12 text-center">
              <div className="py-8">
                <h2 className="text-2xl md:text-[40px] text-center leading-none font-bold pt-12 md:pt-10">
                  About Us
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className="ezy__header1 light py-14 md:py-24 bg-white text-black relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 relative">
          <div className="grid grid-cols-12">
            <div className="col-span-12 lg:col-span-7 xl:pr-12 text-center lg:text-start">
              <div className="flex flex-col justify-center h-full">
                <h2 className="text-3xl font-bold leading-tight md:text-[40px] mb-4 uppercase">
                  Who We Are
                </h2>
                <p className="text-[16px] leading-normal mb-12">
                  Welcome to Infrec, where we take care of all your financial needs, so you don't have to. Whether you're newly married, planning for a growing family, or looking for retirement or protection solutions, we are here to guide you every step of the way. We specialize in personalized financial planning across India, helping individuals and families achieve their financial goals with ease. With our certified financial consultants and innovative tools like the Financial Health Calculator, we are equipped to tackle all your financial challenges and provide you with peace of mind.
                </p>
                <div>
                  {/* <a
									href="#!"
									className="text-lg py-3 px-7 bg-white shadow rounded-lg"
								>
									Try Now
								</a> */}
                </div>
              </div>
            </div>

            <div className="col-span-12 lg:col-span-5 mt-12 lg:mt-0">
              <img
                src={Aboutus}
                alt=""
                className="max-w-full h-[60vh] mt-4"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 md:py-36 bg-skyBlue relative overflow-hidden z-10">
        <div className="max-w-7xl px-4 mx-auto">
          <div className="flex justify-start text-start">
            <div>
              <h1 className="text-3xl font-bold leading-tight md:text-[40px] mb-4 uppercase">
                Mission and Vision
              </h1>
            </div>
          </div>
          <div className="grid grid-cols-12 gap-6">
            <div className="col-span-12 lg:col-span-6">
              <img
                src="https://cdn.easyfrontend.com/pictures/services/service20.png"
                alt=""
                className="max-w-full h-auto md:mt-12"
              />
            </div>
            <div className="col-span-12 lg:col-span-5 mt-12">
              {features.map((feature, i) => (
                <FeaturedItem feature={feature} key={i} index={i} />
              ))}
            </div>
          </div>
        </div>
      </section>


      <section className="py-14 md:py-24 bg-white relative overflow-hidden z-10">
        <div className="max-w-7xl px-4 mx-auto">
          <div className="grid grid-cols-12 gap-6">
            <div className="col-span-12 md:col-span-7">
              <h1 className="text-3xl font-bold leading-tight md:text-[40px] mb-4 uppercase">
                Why Choose Us?
              </h1>
              <p className="text-lg opacity-80 leading-7 my-12">
                We believe in understanding your unique financial situation, goals, and challenges, ensuring we offer tailored solutions that align with your life’s objectives.
              </p>
              <div>
                {features1.map((feature, i) => (
                  <FeaturedItem1 feature={feature} key={i} />
                ))}
              </div>
            </div>
            <div className="col-span-12 md:col-span-5 md:col-start-8">
              <div className="relative z-10 h-full">
                <div className="absolute -bottom-8 -right-8 h-full w-full bg-blue-600 bg-opacity-10 -z-10" />
                <div
                  className="bg-center bg-no-repeat bg-cover min-h-[200px] h-full"
                  style={{
                    backgroundImage:
                      "url(https://images.pexels.com/photos/5816288/pexels-photo-5816288.jpeg?auto=compress&cs=tinysrgb&w=600)",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Team/>
      <Testimonials />

    </React.Fragment>
  );
};
export default About;